/**
 * 앱 레벨 오류를 #err 패널에 그대로 띄운다. 헤드셋/모바일엔 콘솔이 없으므로
 * 사용자가 메시지를 읽고 복사할 수 있게 하는 게 목적이다.
 * (모듈 로드 이전의 초기 오류 안전망은 index.html의 인라인 스크립트가 담당한다.)
 */
export function showError(message: string): void {
  const pre = document.getElementById('errmsg');
  const panel = document.getElementById('err');
  if (pre) pre.textContent = message;
  if (panel) panel.style.display = 'block';
}
